import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import mx5 from "../../../../assets/info/mx5-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import part1 from "../../../../assets/info/mazda-mx-5/803287_4.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";

const MazdaMX5 = () => {
  useSmallNav("Mazda MX5");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Mazda MX5"} bolder />
        <InfoHero image={mx5} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś posiadaczem MX5? Szukasz części zawieszenia lub ulepszeń zawieszenia?"
              }
            />
            <p>Jeśli tak, to trafiłeś we właściwe miejsce.</p>
            <p>
              W Pedders oferujemy szeroką gamę części zawieszenia i hamulca do
              Twojego MX5, zarówno standardowych, jak i zmodyfikowanych.
            </p>
            <p>
              Oprócz oferowania sprężyn i amortyzatorów, Pedders jest zarówno
              producentem sprężyn, jak i amortyzatorów, co oznacza, że jesteśmy
              w stanie zaoferować Ci naszą koncepcję Pedders Ezifit.
            </p>
            <p>
              Co to jest Ezifit? Ezifit to w pełni zmontowany pakiet sprężyn i
              amortyzatorów. Dostarczany już gotowy i zmontowany amortyzator ze
              sprężyną, górnym mocowaniem, odbojnikiem i osłoną. Gotowy do
              montażu i objęty pełną gwarancją na 2 lata lub 24 000 mil. Zbyt
              Ezi!
            </p>
            <p>
              Są one oferowane zarówno w formacie standardowym, jak i obniżonym,
              więc mamy to, czego potrzebujesz, niezależnie od tego, czy
              przywracasz MX5 do „oryginału”, czy modyfikujesz go w celu poprawy
              wyglądu lub wydajności. Aktualnie są one dostępne dla modeli
              MK1/NA, a wkrótce pojawią się modele MK2/NB.
            </p>
            <p>
              Wersja standardowa wykorzystuje standardowe sprężyny i
              amortyzatory. W amortyzatorach Pedders wprowadzono zmiany w
              zaworach, aby zapewnić lepszą kontrolę, ale nadal oferują poziom
              wydajności i prowadzenia podobny do oryginalnie zamontowanego.
            </p>
            <p>
              W obniżonej wersji zastosowano te same amortyzatory Pedders ze
              sprężynami obniżającymi Pedders, co zapewnia lepsze prowadzenie i
              wygląd.
            </p>
            <p>
              Dla bardziej hardkorowych użytkowników oferujemy również w pełni
              regulowane zestawy gwintowane dla osób korzystających z samochodów
              podczas dni na torze.
            </p>
            <p>
              Jeśli nie widzisz tego, czego potrzebujesz lub nie masz pewności,
              które produkty będą dla Ciebie najlepsze, skontaktuj się z nami, a
              pomożemy Ci w podjęciu decyzji.
            </p>
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Odnawiasz NA MX5? Zużyte cewki? Tylko odświeżenie?"}
              />
              <p>
                Nasze kolumny OEDR Ezifit są właśnie tym, czego potrzebujesz.
                Zestaw 803287
              </p>
              <p>
                Kompletne kolumny, gotowe do montażu bezpośrednio w samochodzie.
                Zawiera wszystkie nowe części. Górne mocowania, odbojnik z
                osłoną, amortyzator, sprężyna, a dla dodatkowego udoskonalenia
                dołączamy także gumowe izolatory sprężyn, których nie miały
                pierwsze samochody.
              </p>
              <p>Po prostu usuń stare kolumny i zamontuj nowe. Zbyt Ezi!</p>
              <p>
                Dostępne jako kompletny zestaw gotowych kolumn w wyjątkowo
                dobrej cenie.
              </p>
              <div>
                <StyledImgParts src={part1} alt="Kit 803287" />
              </div>
            </Gray>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Mazda")
              .models.find((e) => e.display === "MX5")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Mazda" model="MX5" /> */}
      </Container>
    </section>
  );
};

export default MazdaMX5;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
